export default __webpack_public_path__ + "static/media/Curved.83f725ea.svg";